import { createSelector } from '@ngrx/store';

import { Comparer, filterQuickSearchWithTags } from '@common/services/utils.service';
import { BckpConstants } from '@apps/bckp/bckp.constants';
import { getFilterTags } from '@apps/root/store';
import { FilterTag } from '@apps/cmdb/models';

import { getBckpState, IBckpState } from '../bckp.reducer';
import { PolicyDetails, Policy } from '../../domain/models';
import * as fromPoliciesReducer from './policies.reducer';

const getBckpPoliciesState = createSelector(
    getBckpState,
    (state: IBckpState) =>
        state[fromPoliciesReducer.BckpPoliciesFeatureKey]
);
const getPoliciesCollectionState = createSelector(
    getBckpPoliciesState,
    (state) => state.collection
);
export const {
    selectAll: getAllPolicies,
} = fromPoliciesReducer.policiesAdapter.getSelectors(getPoliciesCollectionState);
export const getBckpPoliciesLoadingStatus = createSelector(
    getBckpPoliciesState,
    (state) => state.isLoading
);
export const getBckpPoliciesQueryString = createSelector(
    getBckpPoliciesState,
    (state: fromPoliciesReducer.IBckpPoliciesState) =>
        state.oData.qs
);
export const getBckpPoliciesExportQueryString = createSelector(
    getBckpPoliciesState,
    (state) =>
        state.oData.qsExport
);

export const getBckpPoliciesEmptyStatus = createSelector(
    getBckpPoliciesState,
    (state) =>
        state.isEmpty
);

export const getBckpPoliciesOupsStatus = createSelector(
    getBckpPoliciesState,
    (state) =>
        state.isOups
);

export const getQuickSearchedPolicies = createSelector(
    getBckpPoliciesState,
    getAllPolicies,
    getFilterTags,
    (state: fromPoliciesReducer.IBckpPoliciesState, policies: Policy[], filterTags: FilterTag[]) =>
        filterQuickSearchWithTags(policies, state.qsWord, BckpConstants.policiesQSFields, filterTags)
);

export const getPipelinedPolicies = (comparer: Comparer<Policy>) => createSelector(
    getQuickSearchedPolicies,
    (policies: Policy[]) =>
        policies.sort(comparer)
);

// export const getBckpPoliciesArraySinceUntil = createSelector(
//     getBckpPoliciesState,
//     (state) =>
//         [
//             state.oData.since,
//             state.oData.until
//         ]
// );
// #endregion

// #region Detailed Policies
export const getBckpPoliciesDetailsState = createSelector(
    getBckpPoliciesState,
    (state) => state.detailedPolicies
);

export const {
    selectAll: getAllDetailedPolicies,
} = fromPoliciesReducer.policiesDetailsAdapter.getSelectors(getBckpPoliciesDetailsState);

export const getBckpPolicyDetailsById = createSelector(
    getAllDetailedPolicies,
    (policies: PolicyDetails[], props: { storeId: string }) =>
        policies.filter((p: PolicyDetails) => p.storeId === props.storeId)
);

export const getBckpSelectedPolicyDetails = createSelector(
    getBckpPoliciesState,
    (state) =>
        state.selectedPolicy
);

export const getPoliciesFilter = createSelector(
    getBckpPoliciesState,
    (state) =>
        state.oData.filter
);
export const getBckpPoliciesLoadedStatus = createSelector(
    getBckpPoliciesState,
    (state) => state.isLoaded
);
export const getAllPoliciesByIdentifier = (params: { identifier: string; }) => createSelector(
    getAllPolicies,
    (policies: Policy[]) =>
        policies.filter((policy: Policy) => policy.assetName() === params.identifier)
);
